import DOMPurify from 'dompurify';

const DEFAULT_CONFIG = {
  ALLOWED_TAGS: ['b', 'strong', 'i', 'em', 'u', 's', 'code', 'h1', 'h2', 'h3', 'p', 'br', 'ul', 'ol', 'li', 'a', 'img', 'span', 'div', 'blockquote', 'pre', 'table', 'thead', 'tbody', 'tr', 'th', 'td'],
  ALLOWED_ATTR: ['href', 'src', 'alt', 'style', 'class', 'target', 'rel', 'width', 'height'],
};

export function sanitizeHtml(html, config = {}) {
  if (!html) return '';
  return DOMPurify.sanitize(html, { ...DEFAULT_CONFIG, ...config });
}
